module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: 'variant--' + _vm.variant
  }, [(_vm.types.indexOf('rental') !== -1 && _vm.extradetails('rental').length) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.openRental),
      expression: "openRental"
    }],
    staticClass: "more-details"
  }, [_vm._l((_vm.extradetails('rental')), function(person, k) {
    return _c('div', {
      key: k,
      staticClass: "person"
    }, [_c('div', {
      staticClass: "th"
    }, [_vm._v(_vm._s(Object.values(person)[0][0].skiername))]), _vm._v(" "), _vm._l((Object.values(person)), function(detail, kk) {
      return _c('div', {
        key: 'd' + kk,
        staticClass: "td"
      }, [_c('div', {
        staticClass: "details"
      }, [_vm._l((detail), function(detail2, kkk) {
        return _c('div', {
          key: 'd2' + kkk
        }, [(detail2.productname && detail2.productname.toLowerCase().indexOf('utkörning') !== -1) ? _c('span', [_vm._v(_vm._s(detail2.productname))]) : _c('span', [_vm._v(_vm._s(detail2.productname) + _vm._s(detail2.skierage ? ', ' + detail2.skierage.toLowerCase() : ''))])])
      }), _vm._v(" "), (_vm.skierAttributes(detail[0])) ? _c('div', {
        staticClass: "text-sm"
      }, [_vm._v(_vm._s(_vm.skierAttributes(detail[0])))]) : _vm._e()], 2), _vm._v(" "), _c('div', {
        staticClass: "date"
      }, [_c('div', {
        staticClass: "text-sm"
      }, [_vm._v(_vm._s(detail[0].arrival))]), _vm._v(" "), (detail[0].days) ? _c('div', {
        staticClass: "text-sm",
        staticStyle: {
          "margin-top": "0.25rem"
        }
      }, [_vm._v(_vm._s(detail[0].days) + " dagar")]) : _vm._e()])])
    })], 2)
  }), _vm._v(" "), _c('div', {
    staticClass: "person"
  }, [_c('div', {
    staticClass: "th"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "td"
  }, [_c('div', {
    staticClass: "details"
  }, [_c('button', {
    staticClass: "button--rounded--outlined",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.bookMore('rental')
      }
    }
  }, [_vm._v("Boka mer")])]), _vm._v(" "), _c('div', {
    staticClass: "date"
  }, [_vm._v(" ")])])])], 2) : _vm._e(), _vm._v(" "), (_vm.types.indexOf('skipass') !== -1 && _vm.extradetails('skipass').length) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.openSkipass),
      expression: "openSkipass"
    }],
    staticClass: "more-details"
  }, [_vm._l((_vm.extradetails('skipass')), function(person, k) {
    return _c('div', {
      key: k,
      staticClass: "person"
    }, [_c('div', {
      staticClass: "th"
    }, [_vm._v(_vm._s(Object.values(person)[0][0].skiername))]), _vm._v(" "), _vm._l((Object.values(person)), function(detail, kk) {
      return _c('div', {
        key: 'd' + kk,
        staticClass: "td"
      }, [_c('div', {
        staticClass: "details"
      }, _vm._l((detail), function(detail2, kkk) {
        return _c('div', {
          key: 'd2' + kkk
        }, [_vm._v(_vm._s(detail2.name))])
      }), 0), _vm._v(" "), _c('div', {
        staticClass: "date"
      }, [_c('div', {
        staticClass: "text-sm"
      }, [_vm._v(_vm._s(detail[0].arrival))])])])
    })], 2)
  }), _vm._v(" "), _c('div', {
    staticClass: "person"
  }, [_c('div', {
    staticClass: "th"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "td"
  }, [_c('div', {
    staticClass: "details"
  }, [_c('button', {
    staticClass: "button--rounded--outlined",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.bookMore('skipass')
      }
    }
  }, [_vm._v("Boka mer")])]), _vm._v(" "), _c('div', {
    staticClass: "date"
  }, [_vm._v(" ")])])])], 2) : _vm._e(), _vm._v(" "), (_vm.types.indexOf('skischool') !== -1 && _vm.extradetails('skischool').length) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.openSkischool),
      expression: "openSkischool"
    }],
    staticClass: "more-details"
  }, [_vm._l((_vm.extradetails('skischool')), function(person, k) {
    return _c('div', {
      key: k,
      staticClass: "person"
    }, [_c('div', {
      staticClass: "th"
    }, [_vm._v(_vm._s(Object.values(person)[0][0].skiername))]), _vm._v(" "), _vm._l((Object.values(person)), function(detail, kk) {
      return _c('div', {
        key: 'd' + kk,
        staticClass: "td"
      }, [_c('div', {
        staticClass: "details"
      }, [_vm._l((detail), function(detail2, kkk) {
        return _c('div', {
          key: 'd2' + kkk
        }, [_vm._v(_vm._s(detail2.name))])
      }), _vm._v(" "), (_vm.schoolerAttributes(detail[0])) ? _c('div', {
        staticClass: "text-sm"
      }, [_vm._v(_vm._s(_vm.schoolerAttributes(detail[0])))]) : _vm._e()], 2), _vm._v(" "), _c('div', {
        staticClass: "date"
      }, [_c('div', {
        staticClass: "text-sm"
      }, [_vm._v(_vm._s(detail[0].arrival))])])])
    })], 2)
  }), _vm._v(" "), _c('div', {
    staticClass: "person"
  }, [_c('div', {
    staticClass: "th"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "td"
  }, [_c('div', {
    staticClass: "details"
  }, [_c('button', {
    staticClass: "button--rounded--outlined",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.bookMore('skischool')
      }
    }
  }, [_vm._v("Boka mer")])]), _vm._v(" "), _c('div', {
    staticClass: "date"
  }, [_vm._v(" ")])])])], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e958f98"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/PrettyOrderDetails.vue
// module id = 929
// module chunks = 0